// @flow
import * as Immutable from 'immutable';
import ImmutableModel from 'common/models/flow/ImmutableModel';

export type SectionVisibilitySettingsModelType = {
    showBatchSection: boolean,
    showInsightsSection: boolean,
    showLiveViewSection: boolean,
    showPjpSection: boolean,
    showEntitySection: boolean,
    showAutosortLiveViewSection: boolean,
    showOrderManagementSection: boolean,
    showShipmentManagementSection: boolean,
    showTourDispatchManagementSection: boolean,
    showBaggingSection: boolean,
    showNetOptSection: boolean,
    showTerritorySection: boolean,
    showContractSection: boolean,
    showRosterSection: boolean,
    showOrchestrationSection: boolean
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class SectionVisibilitySettings extends ImmutableModel {
    static fromJS(
        json: SectionVisibilitySettingsModelType
    ): SectionVisibilitySettings {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): SectionVisibilitySettingsModelType {
        return {
            showBatchSection: this.showBatchSection,
            showInsightsSection: this.showInsightsSection,
            showLiveViewSection: this.showLiveViewSection,
            showPjpSection: this.showPjpSection,
            showEntitySection: this.showEntitySection,
            showAutosortLiveViewSection: this.showAutosortLiveViewSection,
            showOrderManagementSection: this.showOrderManagementSection,
            showShipmentManagementSection: this.showShipmentManagementSection,
            showTourDispatchManagementSection: this
                .showTourDispatchManagementSection,
            showBaggingSection: this.showBaggingSection,
            showNetOptSection: this.showNetOptSection,
            showTerritorySection: this.showTerritorySection,
            showContractSection: this.showContractSection,
            showRosterSection: this.showRosterSection,
            showOrchestrationSection: this.showOrchestrationSection
        };
    }

    get showBatchSection(): boolean {
        return this._state.get('showBatchSection');
    }

    setShowBatchSection(showBatchSection: boolean): this {
        return this.clone(
            this._state.set('showBatchSection', showBatchSection)
        );
    }

    get showInsightsSection(): boolean {
        return this._state.get('showInsightsSection');
    }

    setShowInsightsSection(showInsightsSection: boolean): this {
        return this.clone(
            this._state.set('showInsightsSection', showInsightsSection)
        );
    }

    get showLiveViewSection(): boolean {
        return this._state.get('showLiveViewSection');
    }

    setShowLiveViewSection(showLiveViewSection: boolean): this {
        return this.clone(
            this._state.set('showLiveViewSection', showLiveViewSection)
        );
    }

    get showPjpSection(): boolean {
        return this._state.get('showPjpSection');
    }

    setShowPjpSection(showPjpSection: boolean): this {
        return this.clone(this._state.set('showPjpSection', showPjpSection));
    }

    get showEntitySection(): boolean {
        return this._state.get('showEntitySection');
    }

    setShowEntitySection(showEntitySection: boolean): this {
        return this.clone(
            this._state.set('showEntitySection', showEntitySection)
        );
    }

    get showAutosortLiveViewSection(): boolean {
        return this._state.get('showAutosortLiveViewSection');
    }

    setShowAutosortLiveViewSection(showAutosortLiveViewSection: boolean): this {
        return this.clone(
            this._state.set(
                'showAutosortLiveViewSection',
                showAutosortLiveViewSection
            )
        );
    }

    get showOrderManagementSection(): boolean {
        return this._state.get('showOrderManagementSection');
    }

    setShowOrderManagementSection(showOrderManagementSection: boolean): this {
        return this.clone(
            this._state.set(
                'showOrderManagementSection',
                showOrderManagementSection
            )
        );
    }

    get showShipmentManagementSection(): boolean {
        return this._state.get('showShipmentManagementSection');
    }

    setShowShipmentManagementSection(
        showShipmentManagementSection: boolean
    ): this {
        return this.clone(
            this._state.set(
                'showShipmentManagementSection',
                showShipmentManagementSection
            )
        );
    }

    get showTourDispatchManagementSection(): boolean {
        return this._state.get('showTourDispatchManagementSection');
    }

    setShowTourDispatchManagementSection(
        showTourDispatchManagementSection: boolean
    ): this {
        return this.clone(
            this._state.set(
                'showTourDispatchManagementSection',
                showTourDispatchManagementSection
            )
        );
    }

    get showBaggingSection(): boolean {
        return this._state.get('showBaggingSection');
    }

    setShowBaggingSection(showBaggingSection: boolean): this {
        return this.clone(
            this._state.set('showBaggingSection', showBaggingSection)
        );
    }

    get showNetOptSection(): boolean {
        return this._state.get('showNetOptSection');
    }

    setShowNetOptSection(showNetOptSection: boolean): this {
        return this.clone(
            this._state.set('showNetOptSection', showNetOptSection)
        );
    }

    get showTerritorySection(): boolean {
        return this._state.get('showTerritorySection');
    }

    setShowTerritorySection(showTerritorySection: boolean): this {
        return this.clone(
            this._state.set('showTerritorySection', showTerritorySection)
        );
    }

    get showContractSection(): boolean {
        return this._state.get('showContractSection');
    }

    setShowContractSection(showContractSection: boolean): this {
        return this.clone(
            this._state.set('showContractSection', showContractSection)
        );
    }

    get showRosterSection(): boolean {
        return this._state.get('showRosterSection');
    }

    setShowRosterSection(showRosterSection: boolean): this {
        return this.clone(
            this._state.set('showRosterSection', showRosterSection)
        );
    }

    get showOrchestrationSection(): boolean {
        return this._state.get('showOrchestrationSection');
    }

    setShowOrchestrationSection(showOrchestrationSection: boolean): this {
        return this.clone(
            this._state.set(
                'showOrchestrationSection',
                showOrchestrationSection
            )
        );
    }
}
